import { isAxiosError } from "axios";
import axios from "../../../util/axiosConfig";
import { BoardPost } from "../../../component/board/BoardDetail";

export type FreeComment = { id: number; userId: number; authorNickname: string; authorLevel: number; content: string; createdAt: string };
export type FreePost = BoardPost;
export type FreePostItem = Omit<FreePost, "content">;
export type FreePostPage = { items: FreePostItem[]; total: number };
export const freeBoardApi = {
    comments: (id: string, signal?: AbortSignal) => axios.get<FreeComment[]>(`/api/freeboard/${id}/comments`, { signal }),
    addComment: (id: string, content: string) => axios.post<FreeComment>(`/api/freeboard/${id}/comments`, { content }),
    updateComment: (id: number, content: string) => axios.put<FreeComment>(`/api/freeboard/comments/${id}`, { content }),
    deleteComment: (id: number) => axios.delete(`/api/freeboard/comments/${id}`),
    list: (page: number, signal?: AbortSignal) => axios.get<FreePostPage>("/api/freeboard", { params: { page, pageSize: 20 }, signal }),
    read: (id: string, editing = false, signal?: AbortSignal) => axios.get<FreePost>(`/api/freeboard/${id}${editing ? "/edit" : ""}`, { signal }),
    save: (body: { title: string; content: string }, id?: string) => id
        ? axios.put<FreePost>(`/api/freeboard/${id}`, body)
        : axios.post<FreePost>("/api/freeboard", body),
    remove: (id: string) => axios.delete(`/api/freeboard/${id}`),
};

export function boardError(error: unknown): string {
    if (isAxiosError(error)) {
        if (error.response?.status === 401) return "로그인이 필요합니다.";
        if (error.response?.status === 403) return "이 게시글을 수정하거나 삭제할 권한이 없습니다.";
        if (error.response?.status === 404) return "게시글을 불러올 수 없습니다.";
        const message = error.response?.data?.message;
        if (typeof message === "string") return message;
    }
    return "요청을 처리하지 못했습니다. 잠시 후 다시 시도해주세요.";
}
